const f=["#C0C0C0","#ffffcc","#fff"];export{f as BACKGROUND_COLOR};
